import React from 'react';
import { useOnlineStatus } from '../../hooks/onlineStatus';

import { IconInfoCircle } from '@tabler/icons';
import { Container, OfflineBar } from './styles';
import Logo from '../../assets/logo';

const Header: React.FC = () => {
  const isOnline = useOnlineStatus();

  return (
    <>
      <Container>
        <Logo />
      </Container>

      {!isOnline ? (
        <>
          <OfflineBar>
            <IconInfoCircle size={16} style={{ marginRight: 8 }} />
            Offline
          </OfflineBar>
          <div style={{ height: 100 }} />
        </>
      ) : (
        <div style={{ height: 70 }} />
      )}
    </>
  );
};

export default Header;
